import _ from 'lodash'

/** Status com que o back recusa a contrassenha (incorreta, vazia, bloqueado, indisponivel). */
export const HTTP_CONTRASSENHA_RECUSADA = 403

/**
 * Texto da recusa da contrassenha, ou null quando o erro nao e essa recusa. A recusa e 403 em application/json com o
 * texto puro no corpo (texto, e nao objeto: o front em cache do deploy anterior o mostra como mensagem). Um 403 do
 * nginx/WAF vem em text/html: nao e recusa. Content-Type e sempre legivel, mesmo entre origens diferentes.
 */
export const textoRecusaContrassenha = (error) => {
  if (_.get(error, 'response.status') !== HTTP_CONTRASSENHA_RECUSADA) {
    return null
  }
  const tipo = String(_.get(error, ['response', 'headers', 'content-type'], ''))
  const texto = _.get(error, 'response.data')
  return tipo.includes('application/json') && _.isString(texto) ? texto : null
}

/**
 * Respostas do proxy (nginx/balanceador), nao da aplicacao: 502/504 chegam quando o back demorou ou caiu no meio, e a
 * operacao pode ter acontecido do lado de la. Tratadas como sem resposta.
 */
const HTTP_PROXY_INCERTO = [502, 503, 504]

/**
 * A operacao saiu e nao se sabe se aconteceu: enviou e nao voltou resposta (o axios preenche request e nao response),
 * ou voltou uma resposta do proxy. Sem request = falhou antes de enviar, nada aconteceu.
 */
export const resultadoIncerto = (error) => {
  const status = _.get(error, 'response.status')
  if (status) {
    return HTTP_PROXY_INCERTO.includes(status)
  }
  return !!_.get(error, 'request')
}

/** Texto do dialogo -> chave do dicionario do front, usada so quando a busca no back falhou. */
const CHAVES_TEXTOS = {
  titulo: 'contrassenha.label.titulo',
  campo: 'contrassenha.label.campo',
  confirmar: 'contrassenha.label.confirmar',
  cancelar: 'contrassenha.label.cancelar',
  resultadoDesconhecido: 'contrassenha.msg.resultadoDesconhecido',
}

/**
 * Textos do dialogo. Vem do back (dicionario resolvido la), porque o dicionario do front so recarrega no login ou
 * na troca de empresa/unidade. Se a busca falhar, cai no dicionario do front ('contrassenha.label.*'), que existe
 * depois do proximo login. A instrucao depende do tipo; sem tipo conhecido, fica vazia.
 *
 * @param tela resposta de GET /lottustech/contrassenha/tela, ou null se falhou
 * @param dicionario storage.getAppLabels('contrassenha')
 */
export const textosDialogo = (tela, dicionario) => {
  const doBack = _.get(tela, 'textos')
  if (doBack) {
    return doBack
  }
  const textos = {}
  Object.keys(CHAVES_TEXTOS).forEach((chave) => {
    textos[chave] = _.get(dicionario, CHAVES_TEXTOS[chave], '')
  })
  textos.instrucao = ''
  return textos
}

/**
 * A empresa pede um tipo que o back nao suporta: nao adianta digitar. So com a resposta do back em maos. Tipo nulo ou
 * ausente: o back pode omitir campos nulos do JSON.
 */
export const tipoNaoSuportado = (tela) => !!tela && !_.get(tela, 'tipo')

/** Pode enviar: algo digitado, nada em andamento e tipo suportado. */
export const podeConfirmar = (contrassenha, enviando, tela) =>
  !!contrassenha && contrassenha.length > 0 && !enviando && !tipoNaoSuportado(tela)

/**
 * O que fazer com a falha do envio da operacao.
 * - Recusa da contrassenha (403 em application/json, ver textoRecusaContrassenha): fica aberto com o texto do back e o campo limpo, para digitar de novo.
 * - Sem resposta do back (rede caiu, timeout, 502/503/504 do proxy): fica aberto e **incerto** - a operacao pode ter
 *   acontecido (o pagamento pode ter saido). Quem chama mostra o aviso e nao deixa reenviar: reenviar sem conferir pode
 *   pagar duas vezes.
 * - Qualquer outra resposta de erro: fecha - quem chamou ja mostrou a mensagem.
 *
 * @returns {{ manterAberto: boolean, mensagem: string, incerto: boolean }}
 */
export const avaliarFalhaEnvio = (error) => {
  const recusa = textoRecusaContrassenha(error)
  if (recusa !== null) {
    return { manterAberto: true, mensagem: recusa, incerto: false }
  }
  if (resultadoIncerto(error)) {
    return { manterAberto: true, mensagem: '', incerto: true }
  }
  return { manterAberto: false, mensagem: '', incerto: false }
}
